module.exports = "/_next/static/images/2f06def6398c90a4647657594e8faed1-nubank-shooting-hands-diversity@0.5x.jpg.webp";